import styled from 'styled-components';
import { InputLabel } from './InputLabel';

export const SelectLabel = styled(InputLabel)``;

SelectLabel.displayName = 'SelectLabel';
